import { render } from "./taskFile.vue?vue&type=template&id=454800f6&scoped=true"
import script from "./taskFile.vue?vue&type=script&lang=js"
export * from "./taskFile.vue?vue&type=script&lang=js"

import "./taskFile.vue?vue&type=style&index=0&id=454800f6&lang=scss&scoped=true"
import "./taskFile.vue?vue&type=style&index=1&id=454800f6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454800f6"]])

export default __exports__